import React, { useState, useEffect } from "react";
import {
  Accordion,
  Box,
  Button,
  Typography,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Tooltip,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UseProductGroup } from "../../basic-information/productGroup/UseProductGroup";
import { useSnackbar } from "notistack";
import { UseProduct } from "./UseProduct";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress, rsParentChilds } from "../../RecoilStates";
import ProductGroupsChilds from "../../basic-information/productGroup/ProductGroupsChilds";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level4(props) {
  const { validateLvl4Edit } = UseProduct();
  const { enqueueSnackbar } = useSnackbar();
  const [stateValidation, setStateValidation] = useState({
    groupID: false,
  });
  const [level4, setLevel4] = React.useState({
    groupID: "",
  });
  const { isSmall } = useBreakpoints();

  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getGroupList } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [searchToShow, setSearchToShow] = useState("");

  useEffect(() => {
    setProgress(true);
    getGroupList(
      searchToShow,
      (productgroups) => {
        setProgress(false);
        setFiltered(productgroups.productGroups);
      },
      false
    );
  }, [searchToShow]);

  function gotStoreId(id, faName) {
    setLevel4({ groupID: id });

    enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
      variant: "success",
      autoHideDuration: 3000,
      preventDuplicate: true,
    });
  }

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 220,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 70,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Childs">
            <IconButton
              onClick={() => {
                setParentID({
                  id: cellValues.row.id,
                  name: cellValues.row.faName,
                });
              }}
            >
              <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel4(level4);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel4"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله چهارم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
          sx={{ height: "31rem !important", mb: 10 }}
        >
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <TextField
                placeholder="جستجو گروه"
                size="small"
                sx={{ mb: 2, width: isSmall ? "75%" : "40%" }}
                variant="outlined"
                value={searchToShow}
                inputProps={{ "aria-label": "search" }}
                onChange={(evt) => {
                  setParentID({
                    id: null,
                    name: "",
                  });
                  setSearchToShow(evt.target.value);
                }}
              />
              <Box>
                <IconButton
                  sx={{ p: 0, m: 1 }}
                  onClick={() => {
                    setProgress(true);
                    getGroupList(
                      searchToShow,
                      (productgroups) => {
                        setProgress(false);
                        setFiltered(productgroups.productGroups);
                      },
                      false
                    );
                  }}
                >
                  <CachedIcon />
                </IconButton>
                <IconButton sx={{ p: 0 }} href="/productgroups" target="_blank">
                  <LinkIcon />
                </IconButton>
              </Box>
            </Box>
            <DataGrid
              disableVirtualization
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !Important",
                },
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .primary": {
                  width: "100%",
                  backgroundColor: "#ECF6E7 !important",
                },
                "& .none": {
                  width: "100%",
                  backgroundColor: "#fff !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.id == parentID.id) {
                  return "primary";
                }
                if (params.row.id !== parentID.id) {
                  return "none";
                }
              }}
              columns={columns}
              rows={filtered ? filtered : []}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              hideFooter
            />
          </Box>
          <Box
            sx={{ mt: isSmall ? 7 : 0 }}
            gridColumn={isSmall ? "span 12" : "span 6"}
          >
            <ProductGroupsChilds
              searchToShow={searchToShow}
              setSearchToShow={setSearchToShow}
              parentID={parentID}
              ProductGroup
              setGroupID={gotStoreId}
              groupID={level4.groupID}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel3");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation4()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation4() {
    validateLvl4Edit(level4, setStateValidation, () => {
      enqueueSnackbar("مرحله چهارم با موفقیت تکمیل شد", {
        variant: "success",
        autoHideDuration: 2000,
      });
      props.setExpanded("panel5");
    });
  }
}
